import { gql } from "@apollo/client";

const UploadSubscription = gql`
  subscription UploadSubscription {
    listen(topic: "upload_update") {
      query {
        allUploads(orderBy: UPLOADED_DESC) {
          nodes {
            projectName
            projectByProjectName {
              isActive
            }
            imageCount
            id
            status
            uploaded
            zipFileName
            zipFileSize
            imageCount
            isBulk
            inQaqc
            userByUserId {
              appId
              email
              firstName
              lastName
            }
            failedFilesByUploadId {
              totalCount
            }
          }
        }
      }
    }
  }
`;

const hash = "fad3368b413ca923c2a4bd778b196f0af7ff74f2c741e7bb775ae4d23707af77";

export { UploadSubscription, hash };
